import {useEffect,useState,useRef} from 'react';
import { useNavigate,useParams } from "react-router-dom";


import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';


import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import VisibilityIcon from '@mui/icons-material/Visibility';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import TopPrivateNavigation from '../components/TopPrivateNavigation.jsx'
import AppLogout from '../components/AppLogout.jsx'

 import { ToastContainer, toast } from 'react-toastify';
  import 'react-toastify/dist/ReactToastify.css';


//services
import AuthService from '../service/auth'
import SettingsService from '../service/Settings'
import ExportsService from '../service/Exports'
import ProjectService from '../service/Project'


const Exports = () => {
	
	let project_id =ProjectService.getCurrentProject();//params.id;
	console.log('project_id',project_id);
	
	const navigate = useNavigate();
	//protected page check if logged in
	const [globalSettings,setGlobalSettings]=useState({});//global config
	const [globalSettingsLoaded,setGlobalSettingsLoaded]=useState(false);//global config
	const [modulesEnabled,setModulesEnabled]=useState({'questionnaires':false,'recipes':false,'smart_portions':false});
	const [currentUser,setCurrentUser]=useState({});
	const [devMode,setDevMode]=useState({});
	
	const [projectData,setProjectData]=useState([]);
	const [projectFound,setProjectFound]=useState(false);
	const [projectLoaded,setProjectLoaded]=useState(false);
	
	let filter={};
	
	const [exportTables,setExportTables]=useState([]);
		
	useEffect(() => {
		
		let _loggedInStatus = AuthService.getUserLoggedInStatus();
		if(_loggedInStatus.loggedIn){
			setCurrentUser(AuthService.getCurrentUser());
			setDevMode(AuthService.isDevMode());
			SettingsService.getAllFormatted().then(function(res){
				let _globalSettings=res.data;
				setGlobalSettings(res.data);
				setGlobalSettingsLoaded(true);
				console.log(res.data);
				
				var account_type=AuthService.getCurrentUser().__t;
				console.log('account_type',account_type);
				
				if(typeof _globalSettings.modules!=="undefined"){

					//update local modules enabled variables
					setModulesEnabled({
						'questionnaires':_globalSettings.modules.settings.questionnaires.on,
						'recipes':_globalSettings.modules.settings.recipes.on,
						'smart_portions':_globalSettings.modules.settings.smart_portions.on
					});
			
				}else{
					
					console.log('not defined!!');
				}
					if(typeof table!=="undefined"){
						setTableFound(true);
						setTableName(table);
					}
							
					if((typeof project_id !=="undefined")&&(project_id!==null)){//project filter
						loadProjectById(project_id);
						loadExportList('project');
					}else{
						loadExportList('global');
					}
							
					//load
					if(account_type=='Admin'){//Admin
						
					}else if(account_type=='Master'){//Master
							
								
					}else if(account_type=='Researcher'){//Researcher
								
					}

			}).catch(function(error){
				console.log(error);
			});
		}else{
			navigate(_loggedInStatus.redirectUrl);
		}

	}, []);
	
	
	function loadProjectById(project_id){
		ProjectService.getById(project_id).then(function(res){
			setProjectData(res.data);
			console.log(res.data);
			setProjectFound(true);
			setProjectLoaded(true);
		}).catch(function(error){
			console.log(error);
			setProjectFound(false);
		});
	}
		
	function loadExportList(type,project){
		ExportsService.getFilteredList().then(function(res){
			if(type=='global'){
				sortGlobalList(res.data);
			}
			if(type=='project'){
				sortProjectList(res.data);
			}
			console.log(res.data);
			}).catch(function(error){
				console.log(error);
		});
	}
	
	function sortGlobalList(list){
		let _list=[];
		for(let i=0;i<list.length;i++){
			if(list[i].active){
				if(list[i].global){
					_list.push(list[i]);
				}
			}
		}
		setExportTables(_list);
	}
	
	function sortProjectList(list){
		let _list=[];
		for(let i=0;i<list.length;i++){
			if(list[i].active){
				if(list[i].project){
					_list.push(list[i]);
				}
			}
		}
		setExportTables(_list);
	}
	
	const [downloadUrl,setDownloadUrl]=useState("");
	const stateRef = useRef();
	stateRef.loaded = false;
	
	const handleDownload = (e,row) => {
		console.log('row',row.table);
		var _table =row.table;
		var _filter={};
		if(_table=='foods'){
			if((typeof project_id !=="undefined")&&(project_id!==null)){//project filter
				_filter={'global':false,'approved':true,'project':project_id};
			}else{
				_filter={'global':true,'approved':true};
			}
		}
		else{
		//if((_table=='test')||(_table=='clients')||(_table=='client_log')||(_table=='client_log_daily_totals')||(_table=='client_log_daily_averages')||(_table=='client_questionnaires')){
			if((typeof project_id !=="undefined")&&(project_id!==null)){//project filter
				_filter={'project':project_id};
			}else{
				_filter={};
			}
		}
		console.log('_filter',_filter);
		ExportsService.build(_table,_filter).then(function(res){
			console.log(res.data);
			
			if(res.data.found){
				var filename =res.data.filename;
				var url=ExportsService.getUrl(filename);
				console.log('url',url);
				setDownloadUrl(url);
				
				var counter=0;
				var refreshIntervalId = setInterval(function(){
				checkIfBuilt(filename);
				if(stateRef.loaded){
					clearInterval(refreshIntervalId);
					window.open(url,'_blank');}
					if(counter==60){
						clearInterval(refreshIntervalId);
						//timedout
						toast.error("Error : unavailable to download !", {
							position:"top-center",
							autoClose:1000,
							hideProgressBar:true,
							theme:"colored",

						});
					}
					counter++;
				}, 1000);
			}else{
				console.log('Not able to download...');
				toast.error("Error : unavailable to download !", {
					position:"top-center",
					autoClose:1000,
					hideProgressBar:true,
					theme:"colored",

						  });
			}
			
						
		}).catch(function(error){
			toast.error("Error : unavailable to download !", {
					position:"top-center",
					autoClose:1000,
					hideProgressBar:true,
					theme:"colored",

						  });
				console.log(error);
		});
	  };
	  
	  function checkIfBuilt(filename){
		  	ExportsService.exists(filename).then(function(res){
			if(res.data.exists){
				stateRef.loaded=true;
			}
		}).catch(function(error){
				console.log(error);
		});
	  }
	  
	  	//https://fkhadra.github.io/react-toastify/introduction/
	const notify = () => toast.success("Success Notification !", {
        position:"top-right",
		autoClose:1000,
		hideProgressBar:true,
		theme:"colored",
     });

  return(
  <>
	<TopPrivateNavigation/>
	<AppLogout>
	 <ToastContainer  />
	<br/>
	{(projectFound) ?
	<>
	<Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/"> Home </Link>
		<Link
          underline="hover"
          color="inherit"
          href="/projects"
        >
          Projects
        </Link>
		<Link
          underline="hover"
          color="inherit"
          href={`/project/${projectData._id}`}
        >
          {projectData.name}
        </Link>

		<Typography color="text.primary">Exports</Typography>
      </Breadcrumbs>
	
	</>
	:<>
	<Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/"> Home </Link>
		<Typography color="text.primary">Export</Typography>
      </Breadcrumbs>
	</>}
	  
	  <br/>
	  <Divider />
		<br/>
	  
	  
	  {/*  
	

	{(currentUser.__t=='Admin') ?
	<>
	
	  <br/> <br/>
	  <Grid container spacing={3}>
		{exportTables.map((row,index) => (
         <Grid key={row.table} item item xs={12} sm={6} md={4}>
			<Card variant="outlined" sx={{ minWidth: 25 }}>
			<CardHeader style={{ textAlign: 'center' }} 
					title={row.title}	
				  />
				<CardContent>
					<Typography variant="h5" component="div">
					
					</Typography>
					<Typography sx={{ mb: 1.5 }} color="text.secondary">
						{row.description}
					</Typography>
					<Typography variant="body2">
					
						<br />
					</Typography>
				</CardContent>
				<CardActions style={{justifyContent:'center'}}>
					<Button onClick={(e) => handleDownload(e,row)} color="primary" variant="outlined"  endIcon={<FileDownloadIcon />}   size="small" >
						Download csv
					</Button>
				</CardActions>
			</Card>	
		</Grid>))}
	</Grid>
	
	</>
	:<></>}
	
	
	{(currentUser.__t=='Master') ?
	<>*/}
	
	  <br/> <br/>
	  <Grid container spacing={3}>
		{exportTables.map((row,index) => (
         <>
		{row.active ?
		<>
		 <Grid key={row.table} item item xs={12} sm={6} md={4}>
			<Card variant="outlined" sx={{ minWidth: 25 }}>
			<CardHeader style={{ textAlign: 'center' }} 
					title={row.title}	
				  />
				<CardContent>
					<Typography variant="h5" component="div">
					
					</Typography>
					<Typography sx={{ mb: 1.5 }} color="text.secondary">
						{row.description}
					</Typography>
					<Typography variant="body2">
					
						<br />
					</Typography>
				</CardContent>
				<CardActions style={{justifyContent:'center'}}>
					<Button onClick={(e) => handleDownload(e,row)} color="primary" variant="outlined"  endIcon={<FileDownloadIcon />}   size="small" >
						Download csv
					</Button>
				</CardActions>
			</Card>	
		</Grid>
		</>:<></>}
		</>
		))}
	</Grid>
	{/*
	</>
	:<></>}*/}
	
	{/* Researcher */}
		{/*{(currentUser.__t=='Researcher') ?
	<>

	  <br/> <br/>
	  <Grid container spacing={3}>
		{exportTables.map((row,index) => (
         <Grid key={row.table} item item xs={12} sm={6} md={4}>
			<Card variant="outlined" sx={{ minWidth: 25 }}>
			<CardHeader style={{ textAlign: 'center' }} 
					title={row.title}	
				  />
				<CardContent>
					<Typography variant="h5" component="div">
					
					</Typography>
					<Typography sx={{ mb: 1.5 }} color="text.secondary">
						{row.description}
					</Typography>
					<Typography variant="body2">
					
						<br />
					</Typography>
				</CardContent>
				<CardActions style={{justifyContent:'center'}}>
					<Button onClick={(e) => handleDownload(e,row)} color="primary" variant="outlined"  endIcon={<FileDownloadIcon />}   size="small" >
						Download csv
					</Button>
				</CardActions>
			</Card>	
		</Grid>))}
	</Grid>
	
	</>
	:<></>}*/}

	</AppLogout>
	</>
  ) 
  ;
};

export default Exports;
